module.exports = __webpack_public_path__ + "static/media/person.6d6ebef2.svg";